export const state = () => ({
  latestExpertResponses: {
    data: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
      from: null,
      to: null,
      has_more_pages: false,
      next_page_url: null,
      prev_page_url: null
    },
    loading: false,
    error: null
  },
  latestClientContacts: {
    data: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
      from: null,
      to: null,
      has_more_pages: false,
      next_page_url: null,
      prev_page_url: null
    },
    loading: false,
    error: null
  },
  staffTargets: {
    // { timezone, today, date, month, targets, me } from GET /api/dashboard/staff-targets
    data: null,
    loading: false,
    error: null
  },
  teamTargets: {
    // { timezone, today, from, to, range, targets, team } from GET /api/dashboard/staff-targets/team
    data: null,
    loading: false,
    error: null
  }
})
